import { BrowserRouter as Router,Route,Routes } from 'react-router-dom';
import './App.css';
import  Inicio from "../src/pages/inicio";
import Nosotros from "../src/pages/nosotros";
import Navbar from './components/nav_componet';
import Servicios from './pages/servicios';
import ContactoPeru from './pages/contactoPeru';
import FooterApp from './components/footer';
import ContactoMexico from './pages/contactoMexico';
import FloatingButton from './components/buttonFlotanteWha';
import ScrollToTop from './components/scrollToTop';
import Certificaciones from "./pages/certificaciones"
import OtrosServicios from './pages/otrosServicios';
function App() {

  return (
    <Router>
      <ScrollToTop />
       <Navbar/>
        <Routes>
          <Route  path='/' element={<Inicio/> }/>
          <Route  path='/nosotros' element={<Nosotros/> }/>
          <Route  path='/servicios' element={<Servicios/> }/>
          <Route  path='/capacitaciones' element={<Servicios/> }/>
          <Route  path='/perú' element={<ContactoPeru/> }/>
          <Route  path='/méxico' element={<ContactoMexico/> }/>
          <Route  path='/certificaciones' element={<Certificaciones/>}/>
          <Route  path='/otros-servicios' element={<OtrosServicios/>}/>
          
          
         
          </Routes>   
          <FloatingButton/>
          <FooterApp/>


    </Router>
  
  );
}

export default App;
